const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  let token;

  try {
    const userData = JSON.parse(localStorage.getItem("PAuser") || "{}");
    token = userData?.message?.token;
  } catch (error) {
    console.error("Error parsing token from localStorage", error);
  }

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  if (typeof input === "string" && input.includes(backendUrl)) {
    init.headers = {
      ...(init.headers || {}),
      Authorization: token ? `Bearer ${token}` : "",
    };
  }

  return originalFetch(input, init);
};